import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.664 1.542c.345 0 .625.28.625.625v.904L6.6 2.81a7.86 7.86 0 0 1 4.459.41l.17.067a6.04 6.04 0 0 0 3.708.252 1.625 1.625 0 0 1 2.019 1.576v6.14c0 .823-.56 1.541-1.36 1.74l-.179.046c-1.602.4-3.29.286-4.823-.328a6.6 6.6 0 0 0-3.748-.344l-1.557.311v6.155a.625.625 0 0 1-1.25 0V2.167c0-.345.28-.625.625-.625m.625 9.863 1.311-.263a7.86 7.86 0 0 1 4.459.41 6.6 6.6 0 0 0 4.055.275l.179-.045a.545.545 0 0 0 .413-.529V5.114a.375.375 0 0 0-.466-.363 7.3 7.3 0 0 1-4.476-.304l-.17-.068a6.6 6.6 0 0 0-3.748-.344l-1.557.311z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }